import { Alert, Button, Stack, Typography } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import DpcSessions from "./DpcSessions";
import Rewards from "./RewardsCarousel";
import useProduct from "../utils/useProduct";
import DpcCarousel from "./DpcCarousel";
import useCart from "../utils/useCart";
import { useEffect } from "react";
import ConfettiExplosion from "react-confetti-explosion";
import Timeline from "./Timeline";

export default function DpcDouble(){

    const { setCart } = useCart()

    const navigate = useNavigate();

    useEffect(() => {
        setCart({ dpcStep : 1 })
    }, [setCart])

    const product = useProduct()

    const handleContinue = () => {
        window.localStorage.setItem('dpcDoubled', 1);
        navigate(`/courses/${product.reference}/dpc/${product.reference2}`);
    }

    return (

        <Stack spacing={4} sx={{maxWidth: 800, margin: 'auto'}}>

            <Timeline step={1} />

            <Stack alignItems="center">
                <ConfettiExplosion />

                <Alert severity="success" sx={{ textAlign: 'center' }}>
                    Félicitations ! Votre inscription DPC a bien été prise en compte.
                </Alert>
            </Stack>


            <Typography align="center">
                Choisissez votre seconde formation 100% prise en charge avec vos crédits DPC 2026 pour bénéficier de l'offre :
            </Typography>


            <DpcCarousel />


            <DpcSessions />


            <Typography align="center">
                Sélectionnez votre cadeau :
            </Typography>


            <Rewards refFilter="learnyspeed" />


            <Stack direction="row" justifyContent="flex-end" spacing={2}>

                <Button 
                    variant="outlined" 
                    component={Link} 
                    to="/"
                    size="large"
                >
                    Je ne suis pas intéressé(e)
                </Button>
                
                <Button 
                    variant="contained" 
                    onClick={handleContinue}
                    size="large"
                    disabled={!product}
                >
                    Continuer
                </Button>


            </Stack>

        </Stack>
    );
}

